import { ISetUrlInfoAction } from "action/interfaces/utils.interface";
import { IUrlInformation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";

export function setUrlInfo(extendedInfo: IUrlInformation): ISetUrlInfoAction {
  return {
    type: "SET_URL_INFO",
    data: extendedInfo,
  };
}
